import { utils, writeFile } from "xlsx"
import type { TFunction } from "i18next"

import type {
  CouplingLoadView,
  UsinageDetail,
} from "@/features/milling/api/types"

import {
  buildCouplageReport,
  reportSourceKey,
} from "./couplage-report"

// downloadCouplageRapportXlsx writes the chargement × planned-lot
// matrix as a single-sheet workbook shaped like the on-screen panel:
// two-tier header → body rows → TOTAL SACS footer. Planning artifact
// only — no per-lot actual weights. Date column included as a header
// but left empty in each row so an operator can fill it in
// post-export (matches the paper convention).
export function downloadCouplageRapportXlsx(
  usinage: UsinageDetail,
  loads: CouplingLoadView[],
  t: TFunction<"milling">,
) {
  const couplage = buildCouplageReport(usinage, loads)
  const wb = utils.book_new()

  const leftHeaders = [
    t("rapport.cols.date"),
    t("rapport.cols.fournisseur"),
    t("rapport.cols.cccNumber"),
    t("couplageReport.cols.nbreSacs"),
    `${t("couplageReport.cols.poidsNet")} (kg)`,
    `${t("couplageReport.cols.poidsMoyenne")} (kg)`,
  ]
  const lotHeaders = couplage.lots.map((l) => l.label)
  const resteHeader = t("couplageReport.cols.reste")
  const headerRow = [...leftHeaders, ...lotHeaders, resteHeader]

  const bodyRows = couplage.sources.map((s) => {
    const key = reportSourceKey(s.kind, s.id)
    return [
      "",
      s.fournisseur,
      s.cccNumber,
      s.nbreSacs,
      Math.round(s.poidsNetKg),
      Math.round(s.poidsMoyenneKg),
      ...couplage.lots.map((l) => l.bagsBySource[key] ?? 0),
      couplage.resteBySource[key] ?? 0,
    ]
  })

  const totalRow: (string | number)[] = [
    "",
    t("couplageReport.totalSacs"),
    "",
    couplage.totalNbreSacs,
    Math.round(couplage.totalPoidsNetKg),
    Math.round(couplage.totalPoidsMoyenneKg),
    ...couplage.lots.map((l) => couplage.totalBagsByLot[l.id] ?? 0),
    couplage.totalResteSacs,
  ]

  utils.book_append_sheet(
    wb,
    utils.aoa_to_sheet([headerRow, ...bodyRows, [], totalRow]),
    t("couplageReport.sheetName"),
  )

  writeFile(wb, `${couplage.usinageNumber}-couplage.xlsx`)
}
